export default __webpack_public_path__ + "media/images/logo_transparent_black-f9567e300603d3610aad31a93d9a30e6.svg";